<template>
  <div id="vessel-view">
    <h2 v-if="vessel && vessel.name_ja">
      <span class="aisea-text-20-400-black">{{ vessel.name_ja }}</span>
    </h2>
    <h2 v-if="vessel && vessel.name">
      <span class="aisea-text-20-400-black">{{ vessel.name }}</span>
    </h2>

    <div class="tab-component">
      <div 
        class="tab-menu"
        :class='{active: selectedTab==option.key}'
        v-for="(option,index) in tabOptions"
        :key="index"
        @click="tabClicked(option.key)"
      >
        {{option.label}}
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div v-if="selectedTab=='dashBoard'">
          <div class="position-card">
            <card-vessel-position uniqueKey="0" :liveOnly="true" :vesselId="this.$route.params.vesselId"></card-vessel-position>
          </div>
          <vx-card>
            <div class="vx-row">
              <div class="vx-col w-full" :class="{ 'mobile-scroll-parent': isMobileDevice }" >
                <div class="live-data-container"  :class="{ 'mobile-scroll-child': isMobileDevice }">
                  <div class="live-data-card" :class="{'mobile': isMobileDevice}">
                    <div v-if="status" class="status">
                      <span class="status-icon" :class="status.active ? 'active' : 'inactive'"></span>
                      <span class="status-text" :class="status.active ? 'active' : 'inactive'">
                        {{status.label}}
                      </span>
                      <span class="last-updated-text">
                        {{aisReceived}}
                      </span>
                    </div>
                    <div class="card-destination">
                      {{destination}}
                    </div>
                    <div class="eta-text">
                      ETA: {{eta}}
                    </div>
                  </div>
                  <div v-if="speed != null" class="live-data-card" :class="{'mobile': isMobileDevice}">
                    <div class="card-name">
                      速力
                    </div>
                    <span class="card-value">
                      {{speed}}
                    </span>
                    <span class="card-unit">
                      kn
                    </span>
                  </div>
                  <div v-if="heading" class="live-data-card" :class="{'mobile': isMobileDevice}">
                    <div class="card-name">
                      方位
                    </div>
                    <span class="card-value">
                      {{heading}}
                    </span>
                    <span class="card-unit" style="vertical-align: top;">
                      °
                    </span>
                  </div>
                  <div v-if="lat && lng" class="live-data-card" :class="{'mobile': isMobileDevice}">
                    <div class="card-name">
                      緯度/経度
                    </div>
                    <div class="aisea-text-18-400-white">
                      {{lat}}
                    </div>
                    <div class="aisea-text-18-400-white">
                      {{lng}}
                    </div>
                  </div>
                  <VesselLiveDataCard
                    v-for="(element,index) in sortedVesselLiveDataMasterArray" :key="index"
                    :channelId="element.channel_id"
                    :kind="element.kind"
                    :label="element.label"
                    :originNumber="element.origin_number"
                    :vesselId="vesselId"
                  >
                  </VesselLiveDataCard>
                </div>
              </div>
            </div>
          </vx-card>
          <vx-card v-if="enterpriseVessel" class="vessel-container-card">
            <vessel-container-overview 
              :enterpriseVessel="enterpriseVessel"
              :size="'small'"
            />
          </vx-card>
        </div>
        <div v-show="selectedTab=='record'">
          <div class="vx-row">
            <div class="vx-col w-full">
              <card-vessel-info
                @enableVessel="enableVessel"
                @disableVessel="disableVessel"
              />
            </div>
          </div>
          <card-vessel-position uniqueKey="1" :key="index" :vesselId="this.$route.params.vesselId"></card-vessel-position>
        </div>
        <div v-show="selectedTab=='document'">
          <!-- アドオンが読み込まれていない場合は何も表示しない -->
          <div v-if="hasAddonNewDocument === null"></div>
          <div v-else-if="hasAddonNewDocument">
            <card-vessel-new-document />
          </div>
          <div v-else>
            <card-vessel-documents />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const EnterpriseVesselDocument = AiseaApiFactory.get("enterpriseVesselDocument");
const EnterpriseVessel = AiseaApiFactory.get("enterpriseVessel");

import {DeviceInfoMixin} from "@/mixins";
import {DateUtil, GeoUtil} from "@/utils";
import moment from "moment";
import AuthService from "@/services/authService";

//components
import CardVesselInfo from "./components/cardVesselInfo/CardVesselInfo";
import CardVesselPosition from "./components/cardVesselPosition/CardVesselPosition";
import CardVesselDocuments from "./components/cardVesselDocuments/CardVesselDocuments";
import CardVesselNewDocument from "./components/cardVesselNewDocuments/NewDocuments";
import TimelineController from "./components/cardVesselPosition/components/TimeLineControl";
import VesselLiveDataCard from "./components/cardVesselPosition/components/VesselLiveDataCard";
import VesselContainerOverview from "./../../../addon/eco-ship/vessel-container/VesselContainerOverview.vue";

import { createNamespacedHelpers } from "vuex";
const {
  mapState: mapStateOfEnterpriseVesselView,
  mapActions: mapActionsOfEnterpriseVesselView,
} = createNamespacedHelpers("enterpriseVesselView");
const { mapActions: mapActionsOfEcoShip } = createNamespacedHelpers("ecoShip");


export default {
  components: {
    CardVesselInfo,
    CardVesselPosition,
    CardVesselDocuments,
    CardVesselNewDocument,
    TimelineController,
    VesselLiveDataCard,
    VesselContainerOverview,
  },
  mixins: [DeviceInfoMixin],
  data() {
    return {
      id: null,
      data: null,
      index: 0,
      vesselData: null,
      vesselDocumentsData: [],
      voyageHistories: null,
      vesselId: null,
      vesselDestination: null,
      selectedTab: this.initialTab(),
      tabOptions: [
        {
          key: "dashBoard",
          label: "ダッシュボード"
        },
        {
          key: "record",
          label: "航海情報"
        },
        {
          key: "document",
          label: "船舶書類"
        }
      ],
      originVersionMap: {},
      vesselLiveDataMasterArray: [],
      enterpriseVessel: null,
      deviceInfo: null,
      hasAddonNewDocument: null,
    };
  },
  computed: {
    ...mapGetters({
      countryCodes: "constantResource/getCountryCodes"
    }),
    ...mapStateOfEnterpriseVesselView({
      vessel: state => state.vessel,
      vesselLiveAisInfo: state => state.vesselLiveAisInfo,
      vesselLivePosition: state => state.vesselLivePosition,
    }),
    userAddress() {
      let str = "";
      for (let field in this.user_data.location) {
        str += field + " ";
      }
      return str;
    },
    enterpriseId() {
      return this.$store.state.auth.user.id
    },
    destination() {
      if (!this.vesselLiveAisInfo) return "---";
      if (this.vesselLiveAisInfo.eta) {
        return this.vesselLiveAisInfo.dt !== undefined
          ? this.vesselLiveAisInfo.dt
          : "---";
      } else {
        return "---";
      }
    },
    status() {
      let active = this.vesselLivePosition ? this.vesselLivePosition.s === 0 : false
      return {
        active: active,
        label: active ? "航海中" : "停泊中"
      }
    },
    speed() {
      if (this.vesselLivePosition) {
        return this.vesselLivePosition.v !== undefined
          ? this.vesselLivePosition.v
          : "0";
      } else {
        return null
      }
    },
    heading() {
      if (this.vesselLivePosition) {
        return this.vesselLivePosition.h !== undefined ||
          this.vesselLivePosition.h !== 0
            ? this.vesselLivePosition.h
            : this.vesselLivePosition.d !== undefined
              ? this.vesselLivePosition.d
              : "0.0";
      } else {
        return null
      }
    },
    lat() {
      if (this.vesselLivePosition) {
        return this.vesselLivePosition.l !== undefined
          ? `N${GeoUtil.toSexagesimalScale(this.vesselLivePosition.l._lat)}`
          : "---";
      } else {
        return "---";
      }
    },

    lng() {
      if (this.vesselLivePosition) {
        return this.vesselLivePosition.l !== undefined
          ? `E${GeoUtil.toSexagesimalScale(this.vesselLivePosition.l._long)}`
          : "---";
      } else {
        return "---";
      }
    },
    eta() {
      if (!this.vesselLiveAisInfo) return "---";
      if (this.vesselLiveAisInfo.eta) {
        return this.vesselLiveAisInfo.eta.seconds !== undefined
          ? moment(this.vesselLiveAisInfo.eta.seconds, "X").format("YYYY/MM/DD HH:mm")
          : "---";
      } else {
        return "---";
      }
    },
    aisReceived() {
      if (this.vesselLivePosition) {
        return this.vesselLivePosition.t !== undefined
          ? DateUtil.elapsedTimeByTimestamp(this.vesselLivePosition.t)
          : "---";
      } else {
        return "---";
      }
    },
    sortedVesselLiveDataMasterArray() {
      if (this.vesselLiveDataMasterArray) {
      return this.vesselLiveDataMasterArray.sort((a, b) => {
        return (a.sort < b.sort) ? -1 : (a.sort > b.sort) ? 1 : 0;
      })} else {
        return []
      }
    },
    isMobileDevice() {
      if (this.deviceInfo) {
        return this.deviceInfo.deviceType == "iPhone"
      } else {
        return false
      }
    },
    sortedVesselLiveDataMasterArray() {
      let vesselLiveDataMasterArray = this.vesselLiveDataMasterArray;
      if (vesselLiveDataMasterArray) {
        return vesselLiveDataMasterArray.sort((a, b) => {
          return (a.channel_id < b.channel_id) ? -1 : (a.channel_id > b.channel_id) ? 1 : 0;
        }).sort((a, b) => {
          return (a.sort < b.sort) ? -1 : (a.sort > b.sort) ? 1 : 0;
      })} else {
        return []
      }
    },
  },
  methods: {
    ...mapActionsOfEnterpriseVesselView(
      ["resetEnterpriseVesselViewState", "fetchVesselGeneralInfo",
      "fetchVesselLiveDataFirestore", "getVersion", "subscribeChannelDataFirestore", "unsubscribeChannelDataFirestore"
    ]),
    ...mapActionsOfEcoShip(["fetchVessels", "getVesselContainers"]),

    fetchEnterpriseVesselDocuments() {
      return new Promise((resolve, reject) => {
        let params = {
          limit: 20,
          page: 0
        };
        EnterpriseVesselDocument.fetchEnterpriseVesselDocuments(
          this.vesselId,
          params
        )
          .then(response => {
            this.vesselDocumentsData = response.data.documents;
            return resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchEnterpriseVessels() {
      this.$store
        .dispatch("enterpriseVessel/getVessel", this.vesselId)
        .then(response => {
          this.data = response.data;
        })
        .catch(() => {
          this.$vs.loading.close();
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    enableVessel() {
      this.$vs.loading;
      EnterpriseVessel.enable(this.vesselId)
        .then(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "船を運航状態にしました",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-right"
          });
          this.fetchEnterpriseVessels();
        })
        .catch(err => {
          this.$vs.loading.close();
          console.error(err);
        });
    },
    disableVessel() {
      this.$vs.loading;
      EnterpriseVessel.disable(this.vesselId)
        .then(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "船を停止状態にしました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-right"
          });
          this.fetchEnterpriseVessels();
        })
        .catch(err => {
          this.$vs.loading.close();
          console.error(err);
        });
    },
    cleanup() {
      this.resetEnterpriseVesselViewState();
    },
    tabClicked(key) {
      this.selectedTab = key
      if (key == "record" && this.index == 0) this.index++ // 初回のタブ切り替えのときだけサイズ調整のために強制的にコンポーネントを初期化
    },
    uniq(array) { // 配列から重複を取り除く
      return [...new Set(array)];
    },
    async getEnterpriseVesselForContainer() {
      const vesselId = this.$route.params.vesselId;
      const enterpriseVessels = await this.fetchVessels() ;
      const enterpriseVessel = enterpriseVessels.vessels.find(x => x.id === vesselId);
      const vesselContainers = await this.getVesselContainers(enterpriseVessel);
      if ( vesselContainers && vesselContainers.channels && vesselContainers.channels.length > 0 
          && vesselContainers.enterprise_vessel_containers && vesselContainers.enterprise_vessel_containers.length > 0 ) {
        // コンテナ情報が付随している場合は、コンテナ稼働状況カードを生成する（引数：enterpriseVessel）
        this.enterpriseVessel = enterpriseVessel;
      }
    },
    initialTab() {
      if(this.$route.query.tab) return this.$route.query.tab;
      return this.$route.params.fromSdfMenu ? "record" : "dashBoard";
    }
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";
  },
  async created() {
    this.deviceInfo = this.getDeviceInfo()
    this.cleanup()
    this.vesselId = this.$route.params.vesselId;
    this.fetchVesselGeneralInfo(this.vesselId);

    this.hasAddonNewDocument = await AuthService.hasAddon(AuthService.ADDON_IDS.DOCUMENT_MANAGER);
    let payload = {
      vesselId: this.vesselId,
      enterpriseId: this.enterpriseId
    }
    this.vesselLiveDataMasterArray = await this.fetchVesselLiveDataFirestore(payload)
    this.getEnterpriseVesselForContainer();
  },
  beforeDestroy() {
    this.cleanup();
    this.unsubscribeChannelDataFirestore()
  }
};
</script>
<style lang="scss">
#vessel-view {
  .tab-component {
    display: flex;
    border-bottom: 6px solid #3D4656;
    margin-top: 16px;
    margin-bottom: 10px;
    height: 3.4rem;
    .tab-menu {
      padding: 14px 20px 2px 20px;
      cursor: pointer;
      transition: 0.2s;
    }
    .tab-menu.active {
      background: #3D4656;
      font-weight: bold;
      color: #f4f4f4;
      
      border-radius: 5px 5px 0 0;
    }
  }
  .vessel-name {
    margin-bottom: 10px;
  }
  .vessel-name-eg, .vessel-name-ja {
    font-size: 20px;
  }
  .vessel-container-card {
    margin: 10px 0;
  }
  .vs-row {
    .vs-col {
      padding: 0 1rem;
    }
  }
  table {
    width: 100%;
  }
  table tr td {
    font-size: 16px;
    width: 30%;
    vertical-align: top;
    padding-bottom: 0.5rem;
  }
  .position-card {
    margin-bottom: 10px;
  }

  .mobile-scroll-parent {
    margin-left: 0.8rem;
    padding: 0;
    display: flex;
    overflow-x: auto;
    width: 94%;
  }
  .mobile-scroll-child {
    min-width: 860px !important;     
  }

  .vx-card__body {
    padding: 4px !important;
  }


  .live-data-container {
    display: flex;
    flex-wrap: wrap;
    .live-data-card.mobile {
      width: 200px !important;
    }
    .live-data-card {
      font-family: Hiragino Kaku Gothic Pro;
      font-size: 12px;
      background: #3D4656;
      border-radius: 5px;
      width: 210px;
      height: 110px;
      padding: 12px 10px;
      color: #f2f2f2;
      margin: 5px;
      .card-name {
        font-size: 12px;
      }
      .card-value {
        font-size: 18px;
        // &.position-value {
        //   font-size: 18px;
        // }
      }
      .card-unit {
        font-size: 12px;
      }
      .card-destination {
        font-weight: bold;
        font-size: 16px;
      }
      .status {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        .last-updated-text {
          margin-left: auto;
          font-size: 12px;
        }
        .status-icon {
          min-width: 24px;
          min-height: 24px;
          border-radius: 14px;
          margin-right: 10px;
          display: inline-block;
          &.active {
            background-color: #49a0f4;
            border: 4px solid #4585c5;
          }
          &.inactive {
            background-color: #bdbdbd;
            border: 4px solid #98999e;
          }
        }
        .status-text {
          font-size: 17px;
          line-height: 1;
          &.active {
            color: #49a0f4;
          }
          &.inactive {
            color: #bdbdbd;
          }
        }
      }
    }
  }
  .con-vs-loading {
    z-index: 30000;
  }
}
</style>
